export class Notification {
    constructor(public type: string = '',
                public message: string = '',
                public description: string = '',
                public includePremessage: boolean = true
                ) {
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/helper-components/notifications.model.ts